import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { ActionButton } from '@openx/components-header/HeaderActions/ActionButton';
import { useTranslation } from 'react-i18next';

type TroubleshootingNoDataMessageProps = {
  onReload?: () => void;
  isChartsOnly?: boolean;
};

export const TroubleshootingNoDataMessage = ({ onReload, isChartsOnly = false }: TroubleshootingNoDataMessageProps) => {
  const { t } = useTranslation();

  const bodyMessage = isChartsOnly
    ? t('There is no charts data for this deal in the selected date range')
    : t("There's no delivery data for this deal in the selected date range");

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        paddingBottom: theme => theme.spacing(8),
        paddingTop: theme => theme.spacing(8),
      }}
    >
      <Typography variant="h3" data-test="troubleshooting-no-data-header" gutterBottom>
        {t('No Data Available')}
      </Typography>
      <Typography variant="body1" data-test="troubleshooting-no-data-body" color="textSecondary">
        {bodyMessage}
      </Typography>
      {onReload && (
        <ActionButton
          color="default"
          label={t('Reload')}
          disabled={false}
          onClick={onReload}
          sx={{ marginTop: theme => theme.spacing(3) }}
        />
      )}
    </Box>
  );
};
